<script setup lang="ts">
import { cn } from "@client/lib/utils";
import { ToastViewport, type ToastViewportProps } from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<ToastViewportProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ToastViewport
		v-bind="delegatedProps"
		:class="
			cn(
				`tw:fixed tw:top-0 tw:left-0 tw:z-[100] tw:flex tw:max-h-screen tw:w-full tw:flex-col-reverse tw:p-4
				tw:sm:bottom-0 tw:sm:right-0 tw:sm:top-auto tw:sm:flex-col tw:md:max-w-[420px]`,
				props.class,
			)
		" />
</template>
